import { create } from 'zustand';
import { Filter } from '@libs/models/common';
import { AgencyListItem } from '@libs/models/agencies';
import { activateAgency, deactivateAgency, fetchAgenciesList } from '@libs/api/agencies';

type InitialState = {
  initialized: boolean;
  loadingList: boolean;
  agencies: AgencyListItem[];
  page: number;
  perPage: number;
  total: number;
  loadAgencies: (filters?: Filter[], page?: number, perPage?: number) => Promise<void>;
  activateAgency: (id: string) => Promise<void>;
  deactivateAgency: (id: string) => Promise<void>;
};

export const useAgenciesListStore = create<InitialState>()((set) => ({
  initialized: false,
  loadingList: false,
  agencies: [],
  page: 1,
  perPage: 50,
  total: 0,

  loadAgencies: async (filters, page = 1, perPage = 50) => {
    set({ loadingList: true });
    try {
      const resp = await fetchAgenciesList({ filters, page, size: perPage });
      set({
        loadingList: false,
        initialized: true,
        agencies: resp.items,
        page,
        perPage,
        total: resp.totalCount,
      });
    } finally {
      set({ loadingList: false });
    }
  },
  activateAgency: async (id: string) => {
    const resp = await activateAgency(id);
  },
  deactivateAgency: async (id: string) => {
    const resp = await deactivateAgency(id);
  },
}));
